import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "@/utils/helpers";
import { status } from "@/utils/common";

export default {
    namespaced: true,
    state: {
        dispenseRequests: [],
        dispenseRequest: {
            id: null,
            medicines: [],
        },
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.dispenseRequests.findIndex(i => i.id === id)
    },
    mutations: {
        SET_ITEMS: (state, data) => state.dispenseRequests = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SET_ITEM: (state, viewData) => state.dispenseRequest = viewData,
        ADD: (state, addedData) => state.dispenseRequests.unshift(addedData),
        UPDATE: (state, { index, updateData }) => state.dispenseRequests.splice(index, 1, updateData),
        DELETE: (state, index) => state.dispenseRequests.splice(index, 1),
        approval: (state, index) => state.dispenseRequests[index].status = status.active,
        reject: (state, index) => state.dispenseRequests[index].status = status.rejected,

    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");
                const response = await dataService.dispenseRequests.getAll(paramsString);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_ITEMS', response.data.dispenseRequests);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getDetails({ commit }, id) {
            startLoading()
            try {
                commit('SET_ITEM', {});
                const response = await dataService.dispenseRequests.getDetails(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_ITEM', response.data.dispenseRequest);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getForEdit(_, id) {
            startLoading()
            try {
                const response = await dataService.dispenseRequests.getForEdit(id);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data.dispenseRequest);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async add({ commit }, payload) {
            try {
                startLoading()
                const response = await dataService.dispenseRequests.add(payload);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                showNotification(response.data.message);
                commit("ADD", response.data.dispenseRequest);


            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);
            }
        },

        async edit({ commit, getters }, { id, payload }) {
            startLoading()
            try {
                const response = await dataService.dispenseRequests.edit(id, payload);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('UPDATE', { index: index, updateData: response.data.dispenseRequest });

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);
            }
        },
        async delete({ commit, getters }, id) {
            startLoading()
            try {
                const response = await dataService.dispenseRequests.delete(id);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('DELETE', index);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async approval({ commit, getters }, id) {
            try {
                startLoading()
                const response = await dataService.dispenseRequests.approval(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);
                const index = getters.index(id);
                commit("approval", index);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        }, 
        async reject({ commit, getters }, id) {
            try {
                startLoading()
                const response = await dataService.dispenseRequests.reject(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);
                const index = getters.index(id);
                commit("reject", index);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        //---------------------------------------------------------------//
        async getMedicinesStock(_, id) {
            startLoading()
            try {

                const response = await dataService.dispenseRequests.getMedicinesStock(id);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data.stock);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
    },
};
